import { captureSentryLog } from "@/integrations/sentry/client.ts";

const ENV = import.meta.env.VITE_ENV;

/**
 * Captures logs and sends to an aggregated logging service. This is set to send the logs to the console in development
 * environment, but in staging or production environment, it will send the logs to a logging service.
 */
class Logger {
    info(message: string, attributes?: Record<string, unknown>) {
        if (ENV === 'local') {
            console.log(message, attributes);
            return
        }
        captureSentryLog(message, 'info', attributes)
    }

    warn(message: string, attributes?: Record<string, unknown>) {
        if (ENV === 'local') {
            console.warn(message, attributes);
            return;
        }
        captureSentryLog(message, 'warn', attributes)
    }

    trace(message: string, attributes?: Record<string, unknown>) {
        if (ENV === 'local') {
            console.trace(message, attributes);
            return
        }
        captureSentryLog(message, 'trace', attributes)
    }

    debug(message: string, attributes?: Record<string, unknown>) {
        if (ENV === 'local') {
            console.debug(message, attributes);
            return;
        }
        captureSentryLog(message, 'debug', attributes)
    }

    /**
     * Capture and log an error
     * @param message
     * @param attributes
     */
    error(message: string, attributes?: Record<string, unknown>) {
        if (ENV === 'local') {
            console.error(message, attributes);
            return;
        }
        captureSentryLog(message, 'error', attributes)
    }

    fatal(message: string, attributes?: Record<string, unknown>) {
        if (ENV === 'local') {
            console.error(message, attributes);
            return;
        }
        captureSentryLog(message, 'fatal', attributes)
    }
}

export default Logger;
